import React, { useEffect } from "react";
import defaultClasses from "@Components/MyAccount/Data/Info/myAccountInfo.module.scss";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import Field from "../../overrides/venia-ui/components/Field";
import TextInput from "../../overrides/venia-ui/components/TextInput";
import { useIntl } from "react-intl";
import { useFormApi } from "informed";
export const SimpleField = _ref => {
  let {
    showLabel,
    topLabelOverride,
    floatingLabelOverride,
    backgroundClass = "uk-background-creamer",
    borderClass,
    label,
    name,
    type,
    children,
    readOnly = false,
    onClick,
    note,
    required = true,
    requiredStar = false,
    invalid = false,
    prefill = false,
    value,
    before,
    showInvalid,
    disabled = false,
    onFocus = () => {},
    onChange = () => {}
  } = _ref;
  const classes = mergeClasses(defaultClasses);
  const {
    formatMessage
  } = useIntl();
  const api = useFormApi();
  if (value && prefill) {
    api.setValue(name, value);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "uk-width-1-1",
    onClick: onClick
  }, showLabel ? /*#__PURE__*/React.createElement("h3", {
    className: "label uk-text-uppercase uk-margin-small-top uk-margin-small-bottom ".concat(classes.label)
  }, formatMessage({
    id: "".concat(topLabelOverride ? topLabelOverride : label)
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "text ".concat(backgroundClass, " ").concat(borderClass ? borderClass : null, "  uk-border-rounded ").concat(children ? "uk-box-shadow-medium" : "", " ").concat(!showLabel ? "uk-margin-small-top" : "", " ").concat(showInvalid && (invalid || required && !api.getValue(name) && !value) ? "uk-border-red-input shake-incomplete" : "")
  }, /*#__PURE__*/React.createElement(Field, null, children ? children : /*#__PURE__*/React.createElement(TextInput, {
    readOnly: readOnly,
    id: name,
    type: type ? type : "text",
    field: name,
    label: formatMessage({
      id: floatingLabelOverride ? floatingLabelOverride.toLowerCase() : label.toLowerCase()
    }) + (requiredStar ? " *" : ""),
    required: required,
    value: value,
    invalid: invalid,
    before: before,
    disabled: disabled,
    onFocus: onFocus,
    onChange: onChange
  }))), note ? /*#__PURE__*/React.createElement("div", {
    className: "uk-text-muted uk-text-xsmall uk-padding-xsmall-top"
  }, note) : null);
};